import { FC } from "react";
import { useLoaderContextA } from "../../app/hooks/useLoaderContextA";
import { t } from "../../common/miscellaneous/t";

type TopAppMessageProps = {
  readonly children?: unknown;
  readonly title: string;
  readonly imgSrc?: string;
};

export const TopAppMessage: FC<TopAppMessageProps> = (props) => {
  const loaderContext = useLoaderContextA();

  return loaderContext === null ? null : (
    <div className="tw-w-full tw-bg-white tw-p-12 tw-mb-8">
      <div className="tw-bg-amber-100 tw-text-center tw-p-8 tw-shadow-lg">
        <>
          <div className="tw-font-bold tw-mb-4 tw-flex  tw-justify-center tw-items-end tw-gap-2">
            {props.imgSrc ? <img src={props.imgSrc} alt="icon" /> : null}
            <span>{t(props.title)}</span>
          </div>
          {props.children}
        </>
      </div>
    </div>
  );
};
